import Auth from 'j-toker';
import { browserHistory } from 'react-router';
import store from 'store';
import * as authentication from 'actions/authenticationActions';
import * as notifications from 'actions/notificationActions';
import * as userTypes from 'actions/userTypesActions';
import { isAuthenticating } from 'helpers/Authentication/index';
import logoutUser from './logoutUser';

export default function authenticateTenant(nextState, replace, callback) {
  if (isAuthenticating()) {
    return;
  }

  if (!Auth.user || !Auth.user.first_name || !Auth.user.type) {
    return;
  }

  if (Auth.user.type !== 'lead') {
    logoutUser();
    callback();
    return;
  }

  const currentLocation = browserHistory.getCurrentLocation();
  const query = currentLocation.query;

  window.gtag('config', 'GA_MEASUREMENT_ID', {
    page_path: currentLocation.pathname,
  });

  if (currentLocation.pathname === '/tenant_application') {
    store.dispatch(authentication.showApplicationPage());
  } else if (currentLocation.pathname === '/internal_document_portal') {
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/document_portal') {
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/renew_lease') {
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/document_portal_in_person') {
    store.dispatch(authentication.showSignaturePage());
  } else if (query.email_confirmation) {
    store.dispatch(notifications.showSuccess('emailSuccessfullyConfirmed'));

    if (currentLocation.pathname.startsWith('/maintenance')) {
      store.dispatch(userTypes.setUserAsMaintenance(Auth.user));
      store.dispatch(authentication.setMaintenanceLoginParams());
      browserHistory.push('/maintenance' + currentLocation.search);
    } else if (currentLocation.pathname.startsWith('/companies')) {
      store.dispatch(userTypes.setUserAsLandlord(Auth.user));
      store.dispatch(authentication.setLandlordLoginParams());
      browserHistory.push('/companies' + currentLocation.search);
    } else {
      browserHistory.push('/' + currentLocation.search);
    }
  } else if (currentLocation.pathname === '/tenant_referral') {
    browserHistory.push('/tenant_referral' + currentLocation.search);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/lead_capture') {
    browserHistory.push('/lead_capture' + currentLocation.search);
    store.dispatch(authentication.showNonAuthPage());
  } else if (query.property_id && query.application_id && query.renewal_id) {
    browserHistory.push(
      `/tenant_application?property_id=${query.property_id}&application_id=${query.application_id}&renewal_id=${query.renewal_id}`
    );
  } else if (query.property_id && query.application_id) {
    browserHistory.push(
      `/tenant_application?property_id=${query.property_id}&application_id=${query.application_id}`
    );
  } else if (query.property_id && !query.application_id) {
    browserHistory.push(`/tenant_application?property_id=${query.property_id}`);
  } else {
    store.dispatch(authentication.logUserIn(Auth.user.permission));
  }

  callback();
  return;
}
